<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <template #right>
            <div
                class="flex flex-col md:flex-row items-end md:items-center gap-2 w-full"
            >
                <Button
                    as="a"
                    :href="
                        urlFactory.makeCompanyBookingFormUrl(authCompany.slug)
                    "
                    iconName="external-link"
                    iconClass="w-3.5 h-3.5"
                    color="light"
                    target="_blank"
                >
                    View Booking Page
                </Button>
                <ShareLinkButtonModal
                    buttonSize="normal"
                    :analyticsSurface="
                        AnalyticsEventSurfaceEnum.Share_BookingPageLink_IndexServicePage
                    "
                    :shareUrl="
                        urlFactory.makeCompanyBookingFormUrl(authCompany.slug)
                    "
                />
                <CreateServiceButtonDrawer
                    v-if="authCompanyUser.isAdminOrOwner()"
                    :meetingLocations="meetingLocations"
                />
            </div>
        </template>

        <div>
            <div class="grid grid-cols-12 gap-4">
                <template
                    v-for="service in localServices"
                    :key="service.id.value"
                >
                    <div class="col-span-12 lg:col-span-4">
                        <ServiceCard
                            :service="service"
                            :company="authCompany"
                            :showEditService="authCompanyUser.isAdminOrOwner()"
                            :showDeleteService="
                                authCompanyUser.isAdminOrOwner()
                            "
                            @onServiceDeleted="handleServiceDeleted(service)"
                        />
                    </div>
                </template>
            </div>
        </div>
    </AppLayout>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref } from 'vue'
    import Service from '@/App/Service/Entity/Service'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ServiceCard from '@/App/Service/Component/Service/ServiceCard.vue'
    import CreateServiceButtonDrawer from '@/App/Service/Component/Service/CreateServiceButtonDrawer.vue'
    import ShareLinkButtonModal from '@/App/Service/Component/Service/ShareLinkButtonModal.vue'
    import {
        AnalyticsEventSurfaceEnum,
        type MeetingLocationType,
        type PageMeta,
    } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'

    interface IndexServicesProps {
        pageMeta: PageMeta
        appSharedDataData: any
        servicesData: any
        meetingLocations: MeetingLocationType[]
    }

    const props = defineProps<IndexServicesProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const authCompany = appSharedData.getAuthCompany()
    const authCompanyUser = appSharedData.getAuthCompanyUser()
    const localServices = ref<Service[]>(
        Service.hydrateMultiple(props.servicesData),
    )

    const handleServiceDeleted = (deletedService: Service) => {
        localServices.value = localServices.value.filter(
            (services) => services.id !== deletedService.id,
        )
    }
    const urlFactory = new UrlFactory()
</script>
